export function transformOrgColumnIntoDataObject(organizationColumn) {
    const organizationData = {};
    for (const organization of organizationColumn) {
        const [organizationId, organizationProperty] = organization.split('_');
        organizationData[organizationId] = organizationProperty;
    }
    return organizationData;
}
